import { EntityStatus } from "shared/global/enums";
import { StoreMiddlewareEntity } from "shared/global/entities";

const orderState = {
    open: [],
    pending: [],
    history: new StoreMiddlewareEntity({ data: null, status: EntityStatus.IDLE, updateTime: null  }),
}

export default orderState;